import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsDialogModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { ChartModule } from '../chart/chart.module';

import { TrendDialogComponent } from './trend-dialog.component';
import { TranslationIdMap } from './trend-dialog.i18n';

@NgModule({
    declarations: [TrendDialogComponent],
    exports: [TrendDialogComponent],
    imports: [
        CommonModule,
        ChartModule,
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
    ],
})
export class CmpsMi2TrendDialogModule {}
